import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Form, Modal, Level, Toasts, Button, Text } from '@deseretbook/react-ui'
import { DeseretBook } from '../../../dbcom/api'
import {
  AddressFormManager,
  AddressFormFields,
} from '../../forms'

/**
 * New Address View of the subscription signup modal.
 *
 * @returns {function} Component
 */
const NewAddressView = ({ user, onSuccess, changeView }) => {
  const [addressForm, setAddressForm] = useState({})
  const [isSubmitting, setIsSubmitting] = useState(false)

  /**
   * Updates the address form with the given changes.
   *
   * @param {object} [changes={}] - Changes to address
   */
  const updateAddress = (changes = {}) => {
    setAddressForm(prevAddress => ({ ...prevAddress, ...changes }))
  }

  /**
   * Saves the user's address to their address book.
   *
   * @param {object} hostedFields - HostedFields data
   */
  const saveAddress = async () => {
    setIsSubmitting(true)

    try {
      const addressBook = await DeseretBook
        .user(user)
        .addressBook()
        .update(addressForm)


      setIsSubmitting(false)
      Toasts.success('Address saved')

      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess(addressBook)
      }
    } catch (error) {
      setIsSubmitting(false)
      Toasts.danger('Unable to save', error.message)
    }
  }

  return (
    <AddressFormManager
      address={addressForm}
      onChange={updateAddress}
    >
      {/*
        TODO I think paymentMethod defaults to the Spree::Card or whatever, but we should send the
        real thing in probably
      */}
      {addressFormProps => (
        <Form
          onSubmit={saveAddress}
          isSubmitting={isSubmitting}
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Modal.Header>
            <Text isBold hasEllipsis>Create New Address</Text>
          </Modal.Header>
          <Modal.Content>
            <AddressFormFields {...addressFormProps} />
          </Modal.Content>
          <Modal.Footer>
            <Level>
              <Level.Right>
                <Level.Item>
                  <Button
                    type="button"
                    onClick={() => changeView('form')}
                    disabled={isSubmitting}
                  >
                    Cancel
                  </Button>
                </Level.Item>
                <Level.Item>
                  <Form.SubmitButton
                    color="action"
                    disabled={addressFormProps.isFetchingData}
                  >
                    Create New Address
                  </Form.SubmitButton>
                </Level.Item>
              </Level.Right>
            </Level>
          </Modal.Footer>
        </Form>
      )}
    </AddressFormManager>
  )
}

NewAddressView.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  onSuccess: PropTypes.func,
  changeView: PropTypes.func,
}

NewAddressView.defaultProps = {
  onSuccess: () => {},
  changeView: () => {},
}

export default NewAddressView
